// 健康状態新規作成・編集画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Divider,
  Button,
  Snackbar
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './List.css';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import 'date-fns';
import { useRecoilState } from 'recoil';
import { mainBlueColor, btnColor, isLoggedIn, userRole } from '../GlobalState';
import {
  addEmployeeHealthStatus,
  getEmployeeHealthStatusById
} from '../apicalls/employeeMaster';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import { NotFoundPage } from './NotFoundPage';
import { EMPLOYEE_TYPE } from '../const/Const';
import { DatePickerInput } from '../components/atoms';
import { format, parse } from 'date-fns';

export const CreateEmployeeHealthStatus: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission, setUserPermission] = useRecoilState(userRole);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [loading, setLoading] = useState(true);
  const [healthInsuranceEnrollment, setHealthInsuranceEnrollment] =
    useState(''); //加入健康保険
  const [pensionEnrollment, setPensionEnrollment] = useState(''); //加入年金
  const [employmentInsuranceEnrollment, setEmploymentInsuranceEnrollment] =
    useState(''); //加入雇用保険
  const [retirementAidBook, setRetirementAidBook] = useState(false); //建退共手帳
  const [spWorkersCompNum, setSpWorkersCompNum] = useState<string>(''); //労災特別加入番号
  const [healthInsuranceNum, setHealthInsuranceNum] = useState<string>(''); //健康保険番号
  const [pensionNum, setPensionNum] = useState<string>(''); //年金番号
  const [employmentInsuranceNum, setEmploymentInsuranceNum] =
    useState<string>(''); //健康保険番号
  const [workersCompEnrollment, setWorkersCompEnrollment] = useState(false); //労災保険加入
  const [spWorkersCompDate, setSpWorkersCompDate] =
    useState<string | null>(null); //労災特別加入年月日
  const [selectedSpWorkersCompDateValue, setSelectedSpWorkersCompDateValue] =
    useState<Date | null>(null);
  const [healthCheckupDate, setHealthCheckupDate] =
    useState<string | null>(null); //健康診断受診日
  const [selectedHealthCheckupDateValue, setSelectedHealthCheckupDateValue] =
    useState<Date | null>(null);
  const [bloodType, setBloodType] = useState(''); //血液型
  const [minBloodPressure, setMinBloodPressure] = useState(''); //血圧下
  const [maxBloodPressure, setMaxBloodPressure] = useState(''); //血圧上
  const [bloodPressureMedication, setBloodPressureMedication] = useState(''); //血圧薬使用
  const [spHealthCheckupDate, setSpHealthCheckupDate] =
    useState<string | null>(null); //特殊健康診断受診日
  const [
    selectedSpHealthCheckupDateValue,
    setSelectedSpHealthCheckupDateValue
  ] = useState<Date | null>(null);
  const [spHealthCheckupType, setSpHealthCheckupType] = useState(''); //特殊健康診断種類

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        width: matches2 ? 600 : '80%'
      },

      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        height: 60,
        maxHeight: 100,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      },
      topBoxText: {
        fontSize: 14,
        color: '#000000'
      }
    })
  );

  const classes = useStyles();
  const history: any = useHistory();
  const location: any = useLocation();

  // 自社社員か社外パートナーか
  const employeeType: number = history.location.state.employeeType;
  // 編集か新規作成か
  const actionType: string = history.location.state.actionType;
  const isEditMode = actionType === 'edit';
  // 社員ID
  const employeeId: number = history.location.state.employeeId;

  const getAllDetailsOfEmployeeMasterById = () => {
    getEmployeeHealthStatusById(employeeId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setHealthInsuranceEnrollment(data.data.health_insurance_enrollment);
            setHealthInsuranceNum(data.data.health_insurance_number);
            setPensionEnrollment(data.data.pension_enrollment);
            setPensionNum(data.data.pension_number);
            setEmploymentInsuranceEnrollment(
              data.data.employment_insurance_enrollment
            );
            setEmploymentInsuranceNum(data.data.employment_insurance_number);
            setRetirementAidBook(data.data.retirement_aid_book ?? false);
            setSpWorkersCompNum(data.data.sp_workers_comp_number);
            setWorkersCompEnrollment(
              data.data.workers_comp_enrollment ?? false
            );
            handleDate(
              data.data.sp_workers_comp_date,
              setSelectedSpWorkersCompDateValue,
              setSpWorkersCompDate
            );
            handleDate(
              data.data.health_checkup_date,
              setSelectedHealthCheckupDateValue,
              setHealthCheckupDate
            );
            setBloodType(data.data.blood_type);
            setMinBloodPressure(data.data.min_blood_pressure);
            setMaxBloodPressure(data.data.max_blood_pressure);
            setBloodPressureMedication(data.data.blood_pressure_medication);
            handleDate(
              data.data.sp_health_checkup_date,
              setSelectedSpHealthCheckupDateValue,
              setSpHealthCheckupDate
            );
            setSpHealthCheckupType(data.data.sp_health_checkup_type);
            setLoading(false);
          }
        }
      }
    });
  };

  useEffect(() => {
    getAllDetailsOfEmployeeMasterById();
  }, []);

  //保存前の入力値バリデーションと保存処理
  const editEmployeeMasterDetails = () => {
    const trimmedHealthInsurance = healthInsuranceEnrollment?.trim() || '';
    const trimmedEmploymentInsurance =
      employmentInsuranceEnrollment?.trim() || '';
    const trimmedPension = pensionEnrollment?.trim() || '';
    const safeHealthInsuranceNum = healthInsuranceNum || '';
    const safeEmploymentInsuranceNum = employmentInsuranceNum || '';
    const safePensionNum = pensionNum || '';

    if (trimmedHealthInsurance === '') {
      setErrorMessage('加入健康保険名を入力してください。');
      setOpen(true);
    } else if (trimmedHealthInsurance.length > 20) {
      setErrorMessage('加入健康保険名を20文字以内で入力してください。');
      setOpen(true);
    } else if (safeHealthInsuranceNum.length > 20) {
      setErrorMessage('加入健康保険番号を20文字以内で入力してください。');
      setOpen(true);
    } else if (trimmedEmploymentInsurance === '') {
      setErrorMessage('加入雇用保険名を入力してください。');
      setOpen(true);
    } else if (trimmedEmploymentInsurance.length > 20) {
      setErrorMessage('加入雇用保険名を20文字以内で入力してください。');
      setOpen(true);
    } else if (safeEmploymentInsuranceNum.length > 20) {
      setErrorMessage('加入雇用保険番号を20文字以内で入力してください。');
      setOpen(true);
    } else if (trimmedPension === '') {
      setErrorMessage('加入年金名を入力してください。');
      setOpen(true);
    } else if (trimmedPension.length > 20) {
      setErrorMessage('加入年金名を20文字以内で入力してください。');
      setOpen(true);
    } else if (safePensionNum.length > 20) {
      setErrorMessage('加入年金番号を20文字以内で入力してください。');
      setOpen(true);
    } else {
      addEmployeeHealthStatus(
        employeeId,
        healthInsuranceEnrollment,
        healthInsuranceNum,
        pensionEnrollment,
        pensionNum,
        employmentInsuranceEnrollment,
        employmentInsuranceNum,
        workersCompEnrollment,
        spWorkersCompNum,
        spWorkersCompDate || '',
        retirementAidBook,
        healthCheckupDate || '',
        bloodType,
        Number(minBloodPressure),
        Number(maxBloodPressure),
        bloodPressureMedication,
        spHealthCheckupDate || '',
        spHealthCheckupType
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
            }
          }
        }
      });
    }
  };

  //日付文字列をDate型に変換
  const handleDate = (dateString: any, setParsedDate: any, setRawDate: any) => {
    if (dateString) {
      const parsedDate = parse(dateString, 'yyyy-MM-dd', new Date());
      setParsedDate(parsedDate);
      setRawDate(dateString);
    } else {
      setParsedDate(null);
      setRawDate(null);
    }
  };

  //健康診断受診日の更新
  const handleHealthCheckupDateChange = (date: Date | null) => {
    setSelectedHealthCheckupDateValue(date);
    if (date) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      setHealthCheckupDate(formattedDate);
    } else {
      setHealthCheckupDate(null);
    }
  };

  //特殊健康診断受診日の更新
  const handleSpHealthCheckupDateChange = (date: Date | null) => {
    setSelectedSpHealthCheckupDateValue(date);
    if (date) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      setSpHealthCheckupDate(formattedDate);
    } else {
      setSpHealthCheckupDate(null);
    }
  };

  //労災保険加入日の更新
  const handleSpWorkersDate = (date: Date | null) => {
    setSelectedSpWorkersCompDateValue(date);
    if (date) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      setSpWorkersCompDate(formattedDate);
    } else {
      setSpWorkersCompDate(null);
    }
  };

  // パンくずリスト表示パターン(編集)
  let patternName =
    employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
      ? 'employee_masters_edit'
      : 'outside_partnerem_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // パンくずリスト表示パターン(新規)
    patternName =
      employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
        ? 'employee_masters_create'
        : 'outside_partnerem_create';
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userPermission === 2 || userPermission === 3) {
    return <NotFoundPage />;
  }

  return (
    <>
      <AppBarComponent patternName={patternName} />

      {(loading && isEditMode) || userPermission === undefined ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight - 150
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              {employeeType == EMPLOYEE_TYPE['OUTSIDE_PARTNER'] && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <Button
                    style={{
                      minWidth: 90,
                      marginRight: 15,
                      marginBottom: 20,
                      color: '#758283',
                      backgroundColor: '#F5F5F5'
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      // 社外パートナー一覧に戻る
                      history.push('/employee-masters', {
                        employeeType: employeeType
                      });
                    }}
                    startIcon={<ArrowBackIcon />}
                  >
                    戻る
                  </Button>
                </div>
              )}

              <div>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    {employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
                      ? '社員基本情報'
                      : '社外パートナー基本情報'}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: matches2 ? 'row' : 'column'
                  }}
                  className={classes.topList}
                >
                  <div
                    // 空アイテム
                    className='empty-list'
                    style={{ width: 15 }}
                  ></div>
                  <div
                    onClick={() => {
                      if (history.location.state?.employeeId) {
                        history.push(`/employee-masters/${employeeId}/edit`, {
                          employeeId: employeeId,
                          actionType: 'edit',
                          employeeType: employeeType
                        });
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>基本情報</div>
                  </div>
                  <div
                    className='border2'
                    style={{
                      backgroundColor: '#F5F5F5',
                      borderTopColor: '#0099CB',
                      borderBottom: 'none'
                    }}
                  >
                    <div
                      className={classes.topBoxText}
                      style={{ color: '#0099CB' }}
                    >
                      健康状態
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      history.push(
                        `/employee-emergency-info/${employeeId}/edit`,
                        {
                          employeeId: employeeId,
                          actionType: 'edit',
                          employeeType: employeeType
                        }
                      );
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>緊急連絡先情報</div>
                  </div>
                  <div
                    onClick={() => {
                      if (history.location.state?.employeeId) {
                        history.push(
                          `/employee-credentials-info/${employeeId}/edit`,
                          {
                            employeeId: employeeId,
                            actionType: 'edit',
                            employeeType: employeeType
                          }
                        );
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>資格情報</div>
                  </div>
                </div>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      paddingTop: 15,
                      paddingLeft: 15,
                      fontSize: 24
                    }}
                  >
                    {'保険'}
                  </div>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div
                      style={{
                        fontWeight: 'bold',
                        paddingBottom: 5,
                        marginLeft: 15,
                        fontSize: 20
                      }}
                    >
                      {'健康保険'}
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          加入健康保険名<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <select
                            value={healthInsuranceEnrollment}
                            onChange={e => {
                              setHealthInsuranceEnrollment(e.target.value);
                            }}
                            className={classes.selectBoxStyle}
                          >
                            <option value=''>選択してください</option>
                            <option value='健康保険組合'>健康保険組合</option>
                            <option value='協会けんぽ'>協会けんぽ</option>
                            <option value='建設国保'>建設国保</option>
                            <option value='国民健康'>国民健康</option>
                            <option value='適用除外'>適用除外</option>
                            <option value='手続き中'>手続き中</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          加入健康保険番号
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            className={classes.input}
                            value={healthInsuranceNum || ''}
                            onChange={e => {
                              const inputValue = e.target.value;
                              if (/^\d*$/.test(inputValue)) {
                                setHealthInsuranceNum(inputValue);
                              }
                            }}
                            type='text'
                            maxLength={20}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div
                      style={{
                        fontWeight: 'bold',
                        paddingBottom: 5,
                        marginTop: 15,
                        marginLeft: 15,
                        fontSize: 20
                      }}
                    >
                      {'雇用保険'}
                    </div>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          加入雇用保険名<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <select
                            value={employmentInsuranceEnrollment}
                            onChange={e => {
                              setEmploymentInsuranceEnrollment(e.target.value);
                            }}
                            className={classes.selectBoxStyle}
                          >
                            <option value=''>選択してください</option>
                            <option value='日雇保険'>日雇保険</option>
                            <option value='雇用保険No'>雇用保険No</option>
                            <option value='適用除外'>適用除外</option>
                            <option value='手続き中'>手続き中</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          加入雇用保険番号
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            className={classes.input}
                            value={employmentInsuranceNum || ''}
                            onChange={e => {
                              const inputValue = e.target.value;
                              if (/^\d*$/.test(inputValue)) {
                                setEmploymentInsuranceNum(inputValue);
                              }
                            }}
                            type='text'
                            maxLength={20}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div
                      style={{
                        fontWeight: 'bold',
                        paddingBottom: 5,
                        marginTop: 15,
                        marginLeft: 15,
                        fontSize: 20
                      }}
                    >
                      {'年金'}
                    </div>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          加入年金名<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <select
                            value={pensionEnrollment}
                            onChange={e => {
                              setPensionEnrollment(e.target.value);
                            }}
                            className={classes.selectBoxStyle}
                          >
                            <option value=''>選択してください</option>
                            <option value='厚生年金'>厚生年金</option>
                            <option value='国民年金'>国民年金</option>
                            <option value='手続き中'>手続き中</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          加入年金番号
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            className={classes.input}
                            value={pensionNum || ''}
                            onChange={e => {
                              const inputValue = e.target.value;
                              if (/^\d*$/.test(inputValue)) {
                                setPensionNum(inputValue);
                              }
                            }}
                            type='text'
                            maxLength={20}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <div
                      style={{
                        fontWeight: 'bold',
                        paddingBottom: 5,
                        marginLeft: 15,
                        fontSize: 20
                      }}
                    >
                      {'労災保険'}
                    </div>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          労災保険加入
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                          >
                            <div
                              onClick={() => setWorkersCompEnrollment(true)}
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                padding: 8,
                                cursor: 'pointer'
                              }}
                            >
                              <div className='checkbox'>
                                {workersCompEnrollment === true && (
                                  <div className='dot' />
                                )}
                              </div>
                              <div style={{ fontSize: 16, marginLeft: 5 }}>
                                有
                              </div>
                            </div>

                            <div
                              onClick={() => setWorkersCompEnrollment(false)}
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                padding: 8,
                                cursor: 'pointer'
                              }}
                            >
                              <div className='checkbox'>
                                {workersCompEnrollment === false && (
                                  <div className='dot' />
                                )}
                              </div>
                              <div style={{ fontSize: 16, marginLeft: 5 }}>
                                無
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          労災特別加入番号
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          {workersCompEnrollment ? (
                            <input
                              value={spWorkersCompNum}
                              onChange={e => {
                                const inputValue = e.target.value;
                                // 空文字または数値形式の文字列であれば状態を更新
                                if (
                                  inputValue === '' ||
                                  /^\d*$/.test(inputValue)
                                ) {
                                  setSpWorkersCompNum(inputValue);
                                }
                              }}
                              className={classes.input}
                              type='text'
                              maxLength={20}
                            />
                          ) : (
                            <span className={classes.input}></span>
                          )}
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          労災特別加入(更新)
                          <br />
                          年月日
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <div
                            style={{
                              marginRight: 15,
                              backgroundColor: '#FFFFFF',
                              height: 42,
                              paddingBottom: 5,
                              paddingLeft: 5,
                              width: '100%'
                            }}
                            className={'select-div-div'}
                          >
                            <DatePickerInput
                              date={selectedSpWorkersCompDateValue}
                              onChange={handleSpWorkersDate}
                              id={'submission_date'}
                              emptyLabel={'加入・更新日'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{
                        backgroundColor: '#CCCCCC',
                        marginLeft: 15,
                        marginTop: 20
                      }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>建退共手帳</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                          >
                            <div
                              onClick={() => setRetirementAidBook(true)}
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                padding: 8,
                                cursor: 'pointer'
                              }}
                            >
                              <div className='checkbox'>
                                {retirementAidBook === true && (
                                  <div className='dot' />
                                )}
                              </div>
                              <div style={{ fontSize: 16, marginLeft: 5 }}>
                                有
                              </div>
                            </div>

                            <div
                              onClick={() => setRetirementAidBook(false)}
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                padding: 8,
                                cursor: 'pointer'
                              }}
                            >
                              <div className='checkbox'>
                                {retirementAidBook === false && (
                                  <div className='dot' />
                                )}
                              </div>
                              <div style={{ fontSize: 16, marginLeft: 5 }}>
                                無
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 5,
                      fontSize: 24
                    }}
                  >
                    {'健康状態'}
                  </div>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          健康診断受診日
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedHealthCheckupDateValue}
                            onChange={handleHealthCheckupDateChange}
                            id={'submission_date'}
                            emptyLabel={'受診日'}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>血液型</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <select
                            value={bloodType}
                            onChange={e => setBloodType(e.target.value)}
                            className={classes.selectBoxStyle}
                          >
                            <option value=''>選択してください</option>
                            <option value='A'>A型</option>
                            <option value='B'>B型</option>
                            <option value='O'>O型</option>
                            <option value='AB'>AB型</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>血圧</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainer}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <input
                            value={minBloodPressure}
                            onChange={text => {
                              setMinBloodPressure(text.target.value);
                            }}
                            className={classes.input}
                            style={{ width: '45%' }}
                            maxLength={3}
                          />
                          <span style={{ margin: '0 10px' }}>/</span>
                          <input
                            value={maxBloodPressure}
                            onChange={text => {
                              setMaxBloodPressure(text.target.value);
                            }}
                            className={classes.input}
                            style={{ width: '45%' }}
                            maxLength={3}
                          />
                          mmHg
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>血圧薬使用</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={bloodPressureMedication}
                            maxLength={225}
                            onChange={text => {
                              setBloodPressureMedication(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          特殊健康診断受診日
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 15,
                            backgroundColor: '#FFFFFF',
                            height: 42,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            width: '100%'
                          }}
                          className={'select-div-div'}
                        >
                          <DatePickerInput
                            date={selectedSpHealthCheckupDateValue}
                            onChange={handleSpHealthCheckupDateChange}
                            id={'submission_date'}
                            emptyLabel={'受診日'}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          特殊健康診断種類
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={spHealthCheckupType}
                            onChange={text => {
                              setSpHealthCheckupType(text.target.value);
                            }}
                            className={classes.input}
                            maxLength={60}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
            <div style={{ height: 80 }} />
          </div>

          <div
            className='save-btn-container'
            style={{
              backgroundColor: '#FFFFFF',
              position: 'fixed',
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-around',
              padding: 20
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Button
                onClick={() => {
                  editEmployeeMasterDetails();
                }}
                style={{
                  paddingLeft: 50,
                  paddingRight: 50,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
              >
                保存
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};
